/**
 * MES FE 공통 ECharts tree-shaking 등록.
 * vue-echarts는 앱(consumer)의 `echarts/core`를 사용하므로, 지연 로드 SFC 내부 `use()`만으로는
 * 이중 echarts 인스턴스 환경(Tier 3 npm)에서 CanvasRenderer 미등록 오류가 날 수 있다.
 */
import { BarChart, LineChart, PieChart } from 'echarts/charts';
import {
  GraphicComponent,
  GridComponent,
  LegendComponent,
  MarkLineComponent,
  TooltipComponent,
} from 'echarts/components';
import * as echarts from 'echarts/core';
import { LegacyGridContainLabel } from 'echarts/features';
import { CanvasRenderer } from 'echarts/renderers';

let registered = false;

export function registerMesEcharts(): void {
  if (registered) return;
  registered = true;
  echarts.use([
    CanvasRenderer,
    BarChart,
    LineChart,
    PieChart,
    GridComponent,
    GraphicComponent,
    LegendComponent,
    MarkLineComponent,
    TooltipComponent,
    LegacyGridContainLabel,
  ]);
}

registerMesEcharts();
